import {View, Text, Image, Platform, Linking} from 'react-native';
import React from 'react';
import {Images} from '../../../../constants/Images';
interface INotFound {
  title: string;
  description: string;
}

const phoneRegex = /(\+?\d{2}\s?\d{2}\s?\d{4,5}-?\d{4})/g;

const NotFound = ({title, description}: INotFound) => {
  const renderDescription = () => {
    if (!description) return null;

    const parts = description.split(phoneRegex);

    return parts.map((part, index) => {
      if (phoneRegex.test(part)) {
        const numeric = part.replace(/\D/g, '');
        return (
          <Text
            key={index}
            style={{
              color: 'blue',
              textDecorationLine: 'underline',
              fontSize: 16,
              fontFamily: 'TCCC-UnityHeadline Regular',
              lineHeight: 20,
            }}
            onPress={() => Linking.openURL(`https://wa.me/${numeric}`)}>
            {part}
          </Text>
        );
      }

      return (
        <Text
          key={index}
          style={{
            fontSize: 16,
            fontFamily: 'TCCC-UnityHeadline Regular',
            lineHeight: 20,
            color: 'gray',
          }}>
          {part}
        </Text>
      );
    });
  };

  return (
    <View
      style={{
        alignSelf: 'center',
        justifyContent: 'center',
        alignItems: 'center',
        marginBottom: Platform.OS === 'ios' ? 85 : 0,
      }}>
      <View style={{flexDirection: 'row'}}>
        <Image source={Images.biggerGlass} />
        <Image source={Images.warning} />
      </View>
      <Text
        style={{
          fontSize: 22,
          fontFamily: 'TCCC-UnityText Bold',
          lineHeight: 26,
          color: 'black',
          marginTop: 20,
        }}>
        {title}
      </Text>
      <Text
        style={{
          fontSize: 16,
          fontFamily: 'TCCC-UnityHeadline Regular',
          lineHeight: 20,
          color: 'gray',
          maxWidth: 220,
          textAlign: 'center',
          marginTop: 5,
          flexWrap: 'wrap',
        }}>
        {renderDescription()}
      </Text>
    </View>
  );
};

export default NotFound;
